var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-content-container',[_c('viewer-toolbar'),_c('VRContainer',{attrs:{"activity-state":_vm.activityState},on:{"update:activityState":function($event){return _vm.$emit('update:activityState', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }